import React, { useEffect } from 'react';
import './App.css';
import Header from './Header';
import Home from './Home'
import {Route,Routes} from 'react-router-dom';
import Checkout from './Checkout';
import Login from './Login';
import Payment from "./Payment"
import { auth } from './firebase';
import { useStateValue } from './StateProvider';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Orders from './Orders';
const promise = loadStripe('pk_test_51MGmrQI0cImNYz5306vl4LsTgnfmatw0PtJsWd9QZHCtXjq89hJljpCFC8TWRUWZ6Akfux2ureY6zolpeGXahBEd00i3B5GxNX');
function App() {
  const [{},dispatch] = useStateValue();
  
 useEffect(() => {
 auth.onAuthStateChanged(authUser=>{
   console.log('THE USER IS >>>',authUser);
   if(authUser){
     //the user just logged in
     dispatch({
       type:'SET_USER',
       user:authUser
     })
   }else{
     //the user is logged out
     dispatch({
      type:'SET_USER',
      user:null
    })
   }
 })
  }, [])
  return (
    <Routes>
    <Route path="/" element ={
      <>
      <Header/>
      <Home/>
      </>
    }/>
    <Route path="/Checkout" element={<>
      <Header/>
      <Checkout/>
    </>
    } />
    <Route path ="/Login" element={<Login/>}/>
    <Route path ="/Payment" element={
    <> 
     < Header />
     < Elements stripe={promise}>
       <Payment />
       </Elements>
    </>
   
    }
    />
    <Route path ="/orders" element={
      <>
       < Header />
      <Orders/>
      </>
    
    }/>
    </Routes>
  );
}

export default App;





  